import React from 'react';
import { Hero } from '../components/sections/Hero';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { SpecStatsSection } from '../components/sections/SpecStatsSection';
import { ProcessSection } from '../components/sections/ProcessSection';
import { FaqSection } from '../components/sections/FaqSection';
import { ContactBand } from '../components/sections/ContactBand';
export function Home() {
  return <>
      <Hero data-id="element-321" data-mp="29gdaod6y3u7a" />
      <ProblemSection data-id="element-322" data-mp="29fvibrnem04n" />
      <SolutionSection data-id="element-323" data-mp="29fc1yfdejjsq" />
      <BenefitsSection data-id="element-324" data-mp="29i7xxy5ovyej" />
      <SpecStatsSection data-id="element-325" data-mp="2dhqfcjyaxrcm" />
      <ProcessSection data-id="element-326" data-mp="2dhyu6hdzj6qg" />
      <FaqSection data-id="element-327" data-mp="2dj9ziln2wmjo" />
      <ContactBand data-id="element-328" data-mp="2dfm41gy2pq2b" />
    </>;
}